import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import InvoiceLinesGrid from './InvoiceLinesGrid';
import {
  fetchInvoicesLines,
  deleteInvoiceLines,
  changeInvoicesLinesStatus,
  exportLines
} from 'redux/invoices/InvoicesActions';
import {
  fetchInvoiceJurisdictionalBreakdown,
  resetJurisdictionalBreakdown,
} from 'redux/invoiceDetail/InvoiceDetailActions';
import { fetchAllocationRules, applyAllocationRuleToLines } from 'redux/rules/RulesActions';
import { clearAllInvoiceLineFilters } from 'redux/invoiceLinesFilters/InvoiceLinesFiltersActions';

const mapStateToProps = ({ invoices, invoiceDetail, invoiceLinesFilters,  rules }) => ({
  invoicesLines: invoices.invoicesLines,
  fetchingInvoicesLines: invoices.fetchingInvoicesLines,
  pageState: invoices.pageStateLines,
  invoiceDetail: invoiceDetail.invoiceDetail,
  closeSlidingPanelFlag : invoices.closeSlidingPanelFlag,
  rules: rules.rules,
  fetchingRules: rules.fetchingRules,
  allocationPageState: rules.pageState,
  appliedFiltersFlag: invoiceLinesFilters.appliedFiltersFlag,
  applyingAllocationRule: rules.applyingAllocationRule
});

const mapDispatchToProps = dispatch => ({
  invoicesActions: bindActionCreators(
    {
      fetchInvoicesLines,
      exportLines,
      fetchInvoiceJurisdictionalBreakdown,
      resetJurisdictionalBreakdown,
      deleteInvoiceLines,
      changeInvoicesLinesStatus
    },
    dispatch
  ),
  rulesActions: bindActionCreators(
    { fetchAllocationRules, applyAllocationRuleToLines },
    dispatch
  ),
  invoiceLinesFiltersActions: bindActionCreators(
    { clearAllInvoiceLineFilters },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceLinesGrid);



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceLinesGrid/InvoiceLinesGridConnector.js